import { Component } from 'react';
import { Mail, MessageCircle, Phone } from 'lucide-react';
import { WHATSAPP_LINK } from '../constants/supportContactItems';
import './AppErrorBoundary.css';

// Textos fijos en los 3 idiomas del widget: un fallo aquí puede ocurrir antes de que
// LanguageProvider llegue a montarse, así que no podemos depender de useTranslation().
const CONTACT_ITEMS = [
  { icon: Phone, label: '+34 971 58 58 38', href: 'tel:+34971585838' },
  { icon: MessageCircle, label: '+34 622 79 97 96', href: WHATSAPP_LINK },
  { icon: Mail, label: 'info@monkeyjetski.com', href: 'mailto:info@monkeyjetski.com' },
];

class AppErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error inesperado en el widget de reservas:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="app-error-boundary">
        <div className="app-error-boundary__content">
          <p className="app-error-boundary__message">
            Ha ocurrido un error inesperado. Por favor, contáctanos.
            <br />
            An unexpected error occurred. Please contact us.
            <br />
            Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktieren Sie uns.
          </p>
          <ul className="app-error-boundary__contact-list">
            {CONTACT_ITEMS.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="app-error-boundary__contact-link"
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    <Icon size={20} strokeWidth={1.5} aria-hidden="true" />
                    <span>{item.label}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
